<h2 mat-dialog-title>{{title  | translate | async}}</h2>
<mat-dialog-content>
<div class="Dialog-body">
  <form>
    <mat-form-field class="DBSS">
      <mat-select (selectionChange)="stateChanged($event)" placeholder="{{'State'  | translate | async}}"   [(ngModel)]="selectedState" name="Site" 
      [formControl]="state" required>            
        <mat-option *ngFor="let Site of siteCodesList" [value]="Site.Id">
          {{Site.SiteName}} </mat-option>
        </mat-select> 
        <mat-error *ngIf="state.invalid">{{getErrorMessage()}}</mat-error>
    </mat-form-field>
  

    <mat-form-field class="DBSS">
      <mat-select placeholder="{{'Department'  | translate | async}}"   [(ngModel)]="selectedDep" name="Department" required>            
        <mat-option *ngFor="let Department of departmentlist_" [value]="Department.ID">
          {{Department.DepartmentName}} </mat-option>
        </mat-select> 
    </mat-form-field>


    <mat-form-field class="DBSS">
      <mat-select placeholder="{{'Leave Type'  | translate | async}}"   [(ngModel)]="selectedLeaveType" name="LeaveType" required>            
        <mat-option *ngFor="let type of leavesTypesList" [value]="type.Id">
          {{type.Name}} </mat-option>
        </mat-select> 
    </mat-form-field>

<div style="display: flex; flex-direction: row; justify-content:space-between;">
  <mat-form-field appearance="DBSS" >
    <mat-label>{{'Leave From'  | translate | async}}</mat-label>
    <input matInput [matDatepicker]="picker" type="picker" [min]="mindate" [(ngModel)]="LeaveFrom" (ngModelChange)="dateChangedLeaveFrom()" [ngModelOptions]="{standalone: true}" required>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="DBSS" >
    <mat-label>{{'Leave To'  | translate | async}}</mat-label>
    <input matInput [matDatepicker]="picker_" type="picker" [min]="LeaveFrom" [(ngModel)]="LeaveTo" (ngModelChange)="dateChangedLeaveTo()" [ngModelOptions]="{standalone: true}" required>
    <mat-datepicker-toggle matSuffix [for]="picker_"></mat-datepicker-toggle>
    <mat-datepicker #picker_></mat-datepicker>
  </mat-form-field>
</div>
    


    <mat-form-field class="DBSS">
      <textarea matInput type="text" placeholder="{{'Notes'  | translate | async}}" rows="4" name = "Notes"  [(ngModel)]="Notes">  </textarea>
    </mat-form-field>


    <div style="display: flex;min-width: 100%;height:40px">
       
     
        
          <i *ngIf="FilePreview!=''" style="cursor: pointer;vertical-align: bottom; margin-left: 10%;font-size: 40px; color: #3da14b;"
            class="material-icons" class="material-icons" (click)="onClickDownloadForm()">description</i>
            <span *ngIf="NewFileName!=''"style="cursor: pointer;font-size: 13px; max-width: 10em;    overflow-wrap: break-word;">{{NewFileName}}</span>
          <!-- <span style=" white-space: nowrap;"><i class="material-icons sc-icon" (click) ="delete()">delete</i></span> -->
          {{'Attach Doc.'  | translate | async}}
        <i   class="material-icons" (click)="openAttachDoc()" style="cursor: pointer;vertical-align: bottom; margin-left: 2%; ">add</i>        
    </div>


  </form>
  
</div>
</mat-dialog-content>
<mat-dialog-actions style="align-items: flex-end;
display: flex;
flex-direction: row;
justify-content: flex-end;">
  <div class="buttonbelow">
    <button mat-raised-button (click)="DialogClose()">{{'Cancel'  | translate | async}}</button> 
    <button *ngIf="IsEdit==false" mat-raised-button (click)= "CreateOrUpdateLeaveRequest()">{{'Submit'  | translate | async}}</button>     
    <button *ngIf="IsEdit==true" mat-raised-button (click)= "CreateOrUpdateLeaveRequest()">{{'Update'   | translate | async}}</button>         

  </div>
</mat-dialog-actions>
